import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { updateMetaTags, addStructuredData, getSiteUrl } from '../../utils/seo';

const ServiciosPage = () => {
  useEffect(() => {
    const siteUrl = getSiteUrl();
    
    updateMetaTags({
      title: 'Servicios de Vaciado de Pisos El Prat | JUSTCLEAN ELPRAT',
      description: 'Servicios de vaciado de pisos, locales, retirada de muebles y limpieza Diógenes en El Prat de Llobregat. Presupuesto gratis. ☎ 602 36 59 96',
      keywords: 'servicios vaciado pisos, vaciado locales, retirada muebles, limpieza Diógenes El Prat',
      path: '/servicios'
    });

    // Add ItemList Schema for services
    const servicesSchema = addStructuredData({
      "@context": "https://schema.org",
      "@type": "ItemList",
      "name": "Servicios de Vaciado y Limpieza",
      "description": "Servicios profesionales de vaciado de pisos y locales en El Prat de Llobregat",
      "url": `${siteUrl}/servicios`,
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "item": {
            "@type": "Service",
            "name": "Vaciado de pisos y casas",
            "description": "Servicio completo de vaciado de viviendas en El Prat de Llobregat y comarca",
            "provider": {
              "@type": "LocalBusiness",
              "name": "JUSTCLEAN ELPRAT"
            }
          }
        },
        {
          "@type": "ListItem",
          "position": 2,
          "item": {
            "@type": "Service",
            "name": "Vaciado de locales comerciales",
            "description": "Vaciado profesional de oficinas, tiendas, almacenes y locales comerciales",
            "provider": {
              "@type": "LocalBusiness",
              "name": "JUSTCLEAN ELPRAT"
            }
          }
        },
        {
          "@type": "ListItem",
          "position": 3,
          "item": {
            "@type": "Service",
            "name": "Retirada de muebles y electrodomésticos",
            "description": "Servicio especializado en recogida y transporte de muebles y electrodomésticos",
            "provider": {
              "@type": "LocalBusiness",
              "name": "JUSTCLEAN ELPRAT"
            }
          }
        },
        {
          "@type": "ListItem",
          "position": 4,
          "item": {
            "@type": "Service",
            "name": "Limpieza por síndrome de Diógenes",
            "description": "Servicio especializado y discreto para casos de acumulación compulsiva",
            "provider": {
              "@type": "LocalBusiness",
              "name": "JUSTCLEAN ELPRAT"
            }
          }
        },
        {
          "@type": "ListItem",
          "position": 5,
          "item": {
            "@type": "Service",
            "name": "Pintura final",
            "description": "Servicio de pintura profesional para dejar el piso o local listo para entregar",
            "provider": {
              "@type": "LocalBusiness",
              "name": "JUSTCLEAN ELPRAT"
            }
          }
        },
        {
          "@type": "ListItem",
          "position": 6,
          "item": {
            "@type": "Service",
            "name": "Pequeñas reparaciones",
            "description": "Servicio de reparaciones menores para dejar el inmueble en perfectas condiciones",
            "provider": {
              "@type": "LocalBusiness",
              "name": "JUSTCLEAN ELPRAT"
            }
          }
        }
      ]
    });

    return () => {
      document.head.removeChild(servicesSchema);
    };
  }, []);

  const servicios = [
    {
      numero: '01',
      titulo: 'Vaciado de pisos y casas',
      descripcion: 'Servicio completo de vaciado de viviendas en El Prat de Llobregat y comarca. Nos encargamos de retirar todos los muebles, enseres, ropa y objetos personales, dejando el piso completamente vacío y limpio.',
      detalles: [
        'Retirada de todo tipo de muebles y enseres',
        'Vaciado de armarios, trasteros y zonas de almacenaje',
        'Limpieza final del piso tras el vaciado',
        'Gestión legal de residuos y reciclaje',
        'Servicio express en 24-48 horas si es necesario',
      ],
      casos: 'Ideal para herencias, mudanzas, pisos de alquiler, ventas inmobiliarias y renovaciones.',
      imagen: 'https://public.readdy.ai/ai/img_res/6950d2e0f63f29fef11ed3801c54195e.jpg',
      icon: 'ri-home-4-line',
    },
    {
      numero: '02',
      titulo: 'Vaciado de locales comerciales',
      descripcion: 'Vaciado profesional de oficinas, tiendas, almacenes y locales comerciales en El Prat de Llobregat. Servicio adaptado a las necesidades de empresas e inmobiliarias.',
      detalles: [
        'Vaciado de oficinas y espacios de trabajo',
        'Retirada de mobiliario comercial y estanterías',
        'Gestión de equipos informáticos y electrónicos',
        'Limpieza industrial del local',
        'Horarios flexibles para no interferir con la actividad',
      ],
      casos: 'Perfecto para cierres de negocio, cambios de ubicación, renovaciones comerciales y traspasos.',
      imagen: 'https://readdy.ai/api/search-image?query=empty%20commercial%20office%20space%20clean%20white%20walls&width=800&height=600&seq=servicio-2&orientation=landscape',
      icon: 'ri-store-2-line',
    },
    {
      numero: '03',
      titulo: 'Retirada de muebles y electrodomésticos',
      descripcion: 'Servicio especializado en recogida y transporte de muebles, electrodomésticos y enseres voluminosos. Gestión responsable y legal de todos los residuos.',
      detalles: [
        'Recogida de sofás, armarios, camas y todo tipo de muebles',
        'Retirada de electrodomésticos grandes (neveras, lavadoras, etc.)',
        'Transporte de enseres a puntos de reciclaje autorizados',
        'Donación de objetos en buen estado a ONGs',
        'Servicio de carga y descarga incluido',
      ],
      casos: 'Útil para renovación de mobiliario, compra de electrodomésticos nuevos y limpieza de trasteros.',
      imagen: 'https://readdy.ai/api/search-image?query=workers%20loading%20furniture%20into%20truck%20professional%20service&width=800&height=600&seq=servicio-3&orientation=landscape',
      icon: 'ri-truck-line',
    },
    {
      numero: '04',
      titulo: 'Limpieza por síndrome de Diógenes y suciedad extrema',
      descripcion: 'Servicio especializado y discreto para casos de acumulación compulsiva y síndrome de Diógenes en El Prat de Llobregat. Trato profesional, respetuoso y confidencial.',
      detalles: [
        'Equipo especializado en casos de acumulación',
        'Máxima discreción y respeto en todo momento',
        'Limpieza profunda y desinfección completa',
        'Tratamiento de olores y eliminación de plagas si es necesario',
        'Coordinación con servicios sociales si se requiere',
      ],
      casos: 'Esencial para situaciones de acumulación compulsiva, abandono de viviendas y casos de insalubridad.',
      imagen: 'https://readdy.ai/api/search-image?query=professional%20cleaning%20team%20in%20protective%20equipment%20working&width=800&height=600&seq=servicio-4&orientation=landscape',
      icon: 'ri-shield-check-line',
    },
    {
      numero: '05',
      titulo: 'Pintura final',
      descripcion: 'Servicio de pintura profesional para dejar el piso o local listo para entregar. Acabados de calidad con pinturas de primera marca.',
      detalles: [
        'Pintura de paredes y techos con acabado profesional',
        'Preparación de superficies y reparación de desperfectos',
        'Pinturas de alta calidad y larga duración',
        'Limpieza completa tras el trabajo de pintura',
        'Presupuesto cerrado sin sorpresas',
      ],
      casos: 'Ideal para preparar pisos de alquiler, ventas inmobiliarias y renovaciones completas.',
      imagen: 'https://readdy.ai/api/search-image?query=painter%20working%20on%20white%20walls%20fresh%20paint%20finish&width=800&height=600&seq=servicio-5&orientation=landscape',
      icon: 'ri-paint-brush-line',
    },
    {
      numero: '06',
      titulo: 'Pequeñas reparaciones',
      descripcion: 'Servicio de reparaciones menores para dejar el inmueble en perfectas condiciones. Soluciones rápidas y eficientes.',
      detalles: [
        'Reparación de desperfectos en paredes y suelos',
        'Arreglo de puertas, ventanas y cerraduras',
        'Pequeñas reparaciones de fontanería y electricidad',
        'Instalación de elementos básicos (cortinas, lámparas, etc.)',
        'Servicio completo para dejar el piso listo',
      ],
      casos: 'Perfecto para preparar entregas de pisos, reparaciones post-mudanza y mantenimiento básico.',
      imagen: 'https://readdy.ai/api/search-image?query=handyman%20doing%20repairs%20in%20apartment%20with%20tools&width=800&height=600&seq=servicio-6&orientation=landscape',
      icon: 'ri-tools-line',
    },
  ];

  const casosUso = [
    {
      icon: 'ri-parent-line',
      titulo: 'Herencias',
      descripcion: 'Vaciado de pisos heredados con gestión completa de enseres y documentación.',
    },
    {
      icon: 'ri-home-heart-line',
      titulo: 'Mudanzas',
      descripcion: 'Limpieza y vaciado del piso antiguo antes de la entrega de llaves.',
    },
    {
      icon: 'ri-building-2-line',
      titulo: 'Inmobiliarias',
      descripcion: 'Preparación de pisos para venta o alquiler con servicio completo.',
    },
    {
      icon: 'ri-hospital-line',
      titulo: 'Síndrome de Diógenes',
      descripcion: 'Intervención profesional y discreta en casos de acumulación compulsiva.',
    },
    {
      icon: 'ri-bank-line',
      titulo: 'Embargos',
      descripcion: 'Vaciado de viviendas embargadas con gestión legal de residuos.',
    },
    {
      icon: 'ri-store-3-line',
      titulo: 'Cierres de negocio',
      descripcion: 'Vaciado completo de locales comerciales y oficinas.',
    },
  ];

  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        {/* Hero Section */}
        <section className="relative py-16 sm:py-20 bg-gradient-to-br from-primary to-dark text-white pt-28 sm:pt-32">
          <div className="absolute inset-0 opacity-10">
            <div
              className="absolute inset-0"
              style={{
                backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)',
                backgroundSize: '30px 30px',
              }}
            ></div>
          </div>

          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
            <div className="mb-4 text-xs sm:text-sm">
              <a href="/" className="text-white/70 hover:text-white">
                Inicio
              </a>
              <span className="text-white/50 mx-2">&gt;</span>
              <span className="text-white">Servicios</span>
            </div>
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-6 break-words px-2">
              Servicios de vaciado y limpieza en El Prat de Llobregat
            </h1>
            <p className="text-base sm:text-lg md:text-xl text-white/90 max-w-3xl mx-auto px-2">
              Soluciones completas de <strong>vaciado de pisos</strong>, <strong>vaciado de locales</strong> y <strong>limpieza extrema</strong> en El Prat y comarca del Baix Llobregat
            </p>
          </div>
        </section>

        {/* Servicios Detallados */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="space-y-24">
              {servicios.map((servicio, index) => (
                <div
                  key={index}
                  className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${
                    index % 2 === 1 ? 'lg:flex-row-reverse' : ''
                  }`}
                >
                  {/* Imagen */}
                  <div className={`${index % 2 === 1 ? 'lg:order-2' : ''}`}>
                    <div className="relative w-full h-96 rounded-2xl overflow-hidden shadow-xl">
                      <img
                        src={servicio.imagen}
                        alt={servicio.titulo}
                        className="w-full h-full object-cover object-top"
                      />
                      <div className="absolute top-6 left-6 w-20 h-20 bg-primary/90 backdrop-blur-sm rounded-full flex items-center justify-center">
                        <span className="text-3xl font-bold text-white">{servicio.numero}</span>
                      </div>
                    </div>
                  </div>

                  {/* Contenido */}
                  <div className={`${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                    <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-4">
                      <i className={`${servicio.icon} text-3xl text-primary`}></i>
                    </div>
                    <h2 className="text-4xl font-bold text-dark mb-4">{servicio.titulo}</h2>
                    <p className="text-lg text-dark/80 mb-6 leading-relaxed">{servicio.descripcion}</p>

                    <div className="space-y-3 mb-6">
                      {servicio.detalles.map((detalle, idx) => (
                        <div key={idx} className="flex items-start gap-3">
                          <i className="ri-checkbox-circle-fill text-primary text-xl flex-shrink-0 mt-1"></i>
                          <span className="text-dark/80">{detalle}</span>
                        </div>
                      ))}
                    </div>

                    <div className="bg-light p-4 rounded-lg mb-6">
                      <p className="text-sm text-dark/70">
                        <strong>Casos de uso:</strong> {servicio.casos}
                      </p>
                    </div>

                    <a
                      href="/contacto"
                      className="inline-flex items-center gap-2 bg-primary text-white px-6 py-3 rounded-full font-bold hover:bg-opacity-90 transition-all cursor-pointer whitespace-nowrap"
                    >
                      Solicitar Presupuesto
                      <i className="ri-arrow-right-line"></i>
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Casos de Uso */}
        <section className="py-20 bg-light">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-bold text-dark mb-4">
                Casos típicos en los que podemos ayudarte
              </h2>
              <p className="text-lg text-secondary max-w-3xl mx-auto">
                Situaciones habituales donde nuestros servicios de <strong>vaciado de pisos</strong> y <strong>limpieza extrema</strong> son la solución perfecta. <a href="/faq" className="text-primary hover:underline font-semibold">Consulta nuestras preguntas frecuentes</a>
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {casosUso.map((caso, index) => (
                <div
                  key={index}
                  className="bg-white rounded-xl p-6 hover:shadow-lg hover:-translate-y-1 transition-all duration-300"
                >
                  <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-4">
                    <i className={`${caso.icon} text-3xl text-primary`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-dark mb-3">{caso.titulo}</h3>
                  <p className="text-dark/70 leading-relaxed">{caso.descripcion}</p>
                </div>
              ))}
            </div>

            <div className="text-center mt-12">
              <p className="text-base text-secondary mb-6">
                ¿Quieres saber más sobre nuestra empresa y experiencia? <a href="/empresa" className="text-primary hover:underline font-semibold">Conoce nuestro equipo</a>
              </p>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-16 sm:py-20 bg-primary text-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-6 break-words">
              ¿Necesitas alguno de estos servicios?
            </h2>
            <p className="text-base sm:text-xl text-white/90 mb-10">
              Contacta con nosotros y te ofrecemos un presupuesto gratuito en menos de 24 horas
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="tel:+34602365996"
                className="inline-flex items-center justify-center gap-2 sm:gap-3 bg-white text-primary px-6 sm:px-8 py-3 sm:py-4 rounded-full font-bold text-base sm:text-lg hover:bg-opacity-90 transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-line text-xl sm:text-2xl"></i>
                <span>Llamar 602 36 59 96</span>
              </a>
              <a
                href="https://wa.me/34602365996"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 sm:gap-3 border-2 border-white text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full font-bold text-base sm:text-lg hover:bg-white hover:text-primary transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-line text-xl sm:text-2xl"></i>
                <span>WhatsApp</span>
              </a>
              <a
                href="/contacto"
                className="inline-flex items-center justify-center gap-2 sm:gap-3 border-2 border-white text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full font-bold text-base sm:text-lg hover:bg-white hover:text-primary transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-mail-line text-xl sm:text-2xl"></i>
                <span>Formulario</span>
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default ServiciosPage;
